export default "/static/webpack/media/play.5a95522a.svg";